/*
 * @Author: Chao Yang
 * @Date: 2020-08-05 21:27:37
 * @LastEditor: Chao Yang
 * @LastEditTime: 2020-08-13 00:40:28
 */
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { DATE_PICKER_CONFIG_DATA } from '../date-picker-config-data';
import { AdDatePickerComponent } from '../ad-date-picker/ad-date-picker.component';
import { CalendarView, CalendarMonthViewComponent } from 'angular-calendar';
import { setMonth, setYear, format, startOfMonth, endOfMonth, endOfYear, startOfYear } from 'date-fns';

@Component({
  selector: 'ad-date-picker-popup',
  templateUrl: './ad-date-picker-popup.component.html',
  styleUrls: ['./ad-date-picker-popup.component.scss'],
})
export class AdDatePickerPopupComponent implements OnInit {
  view: CalendarView = CalendarView.Month;
  showMonthPopup = false;
  showYearPopup = false;
  viewDate: Date;
  component: AdDatePickerComponent;
  format: string;
  nowDate = new Date();
  maxDate: Date | undefined;
  maxMonth: Date | undefined;
  maxYear: number | undefined;
  minDate: Date | undefined;
  minMonth: Date | undefined;
  minYear: number | undefined;


  @ViewChild('calendar', { static: true }) calendar: CalendarMonthViewComponent;
  constructor(@Inject(DATE_PICKER_CONFIG_DATA) private componentData: any) {
    this.viewDate = componentData.date;
    if (!this.viewDate) {
      this.viewDate = this.removeTime(new Date());
    } else {
      this.viewDate = this.removeTime(this.viewDate);
    }

    this.component = componentData.component;
    this.format = componentData.format;
    this.maxDate = componentData.maxDate;
    this.minDate = componentData.minDate;
    if (this.maxDate) {
      this.maxMonth = this.removeTime(endOfMonth(this.maxDate));
      this.maxYear = this.maxDate.getFullYear();
    }

    if (this.minDate) {
      this.minMonth = this.removeTime(startOfMonth(this.minDate));
      this.minYear = this.minDate.getFullYear();
    }
  }

  ngOnInit() { }

  dayClick(event) {
    this.clearAllSelectedStyle();
    event.cssClass = 'cal-day-selected cal-day-inrange';
    this.component.pickADate(event.date);
    this.component.closePopup();
  }

  clearAllSelectedStyle() {
    this.calendar.view.days.forEach((day) => {
      delete day.cssClass;
    });
  }

  viewDateChange(event) {
    this.viewDate = event;
  }

  monthSelect(month: number) {
    this.viewDate = setMonth(this.viewDate, month - 1);
    this.showMonthPopup = false;
  }
  yearSelect(year: number) {
    this.viewDate = setYear(this.viewDate, year);
    this.showYearPopup = false;
    this.showMonthPopup = true;
  }

  beforeMonthViewRender(event) {
    this.clearAllSelectedStyle();
    const viewDateFmtStr = format(this.viewDate, this.format || 'yyyy/MM/dd');
    this.calendar.view.days.forEach((day) => {
      const fmtDay = format(day.date, this.format || 'yyyy/MM/dd');
      if (fmtDay === viewDateFmtStr) {
        day.cssClass = 'cal-day-selected cal-day-inrange';
      }
      if (!this.dateIsValid(day.date)) {
        day.cssClass = "dtp-cell-disabled";
      }
    });


  }

  dateIsValid(date: Date): boolean {
    if (this.minDate && this.maxDate) {
      return date >= this.minDate && date <= this.maxDate;
    } else if (this.minDate) {
      return date >= this.minDate;
    } else if (this.maxDate) {
      return date <= this.maxDate;
    }
    return true;
  }

  removeTime(date: Date) {
    return new Date(format(date, "yyyy/MM/dd"));
  }

  getYearAndMonth(date: Date) {
    if (date) {
      return +(date.getFullYear() + "" + date.getMonth())
    }
    return NaN;
  }
}
